<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Nova Necessidade de Compra
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-listar-necessidades-solicitante' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="q-ml-md">
      <section
        class="row col-12 q-mt-md q-gutter-sm text-brand-1 text-weight-bold"
      >
        <div class="col-md col-xs">
          <div>Unidade</div>
          <lista-unidades-select
            v-model="unidade.nome"
            v-if="
              !$store.state.autenticacao.cliente.includes('acciona') &&
              !$store.state.autenticacao.cliente.includes('staging-acciona')
            "
          ></lista-unidades-select>

          <q-select
            v-if="
              $store.state.autenticacao.cliente.includes('acciona') ||
              $store.state.autenticacao.cliente.includes('staging-acciona')
            "
            v-model="unidadeAcciona"
            :options="[{ id: 1, nome: 'CENTRAL' }]"
            option-label="nome"
            option-value="id"
            dense
            outlined
            disable
            bg-color="grey-3"
            class="input-mobile"
          />
        </div>

        <div class="col-md col-xs">
          <div>Solicitante</div>
          <select-solicitante-compra
            dense
            outlined
            v-model="solicitanteSelecionado"
            :vendor-id="unidade.id"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md col-xs">
          <div>Selecione a Urgência:</div>
          <q-select
            :options="urgencia"
            dense
            outlined
            v-model="urgenciaValue"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md col-xs">
          <div>Selecione o Centro de Custo:</div>
          <q-select
            v-model="selectedCentro"
            option-label="name"
            option-value="code"
            label-color="grey-6"
            :options="listaCentroCustos"
            dense
            outlined
            input-debounce="0"
            @filter="filterCenter"
            use-input
          />
        </div>
      </section>
    </div>

    <div class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span
          >Produtos (digite código ou descrição para encontrar o produto)</span
        >
        <div class="row">
          <q-btn
            icon="list"
            flat
            color="brand-1"
            label="Busca Dinamica"
            no-caps
            @click="confirm = true"
          />
          <q-input
            rounded
            v-model="pesquisarProduto"
            outlined
            dense
            debounce="300"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="listaProdutos"
        title-class="text-brand-5 text-weight-bold"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns2"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        selection="multiple"
        v-model:selected="selectedProdutoTemp"
        row-key="produto_id"
      >
        <template v-slot:body-cell-preco="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            formatPreco(props?.row?.produto_preco)
          }}</q-td>
        </template>
        <template v-slot:body-cell-adicionar="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              icon="add"
              color="positive"
              flat
              dense
              round
              @click="adicionarProduto(props.row)"
            >
              <q-tooltip>Adicionar produto como nova linha</q-tooltip>
            </q-btn>
          </q-td>
        </template>
        <template v-slot:body-cell-desc="props">
          <q-td
            class="text-brand-5 text-weight-bold"
            :props="props"
            style="
              white-space: normal;
              word-break: break-word;
              max-width: 300px;
            "
          >
            {{ props.row.produto_descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-verificarEstoque="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              icon="list_alt"
              color="primary"
              flat
              dense
              outline
              no-caps
              @click="produtoVerificarEstoqueId = props.row.produto_codigo"
            />
          </q-td>
        </template>
      </q-table>
    </div>

    <div v-if="selectedProduto?.length > 0" class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span>Produtos Selecionados</span>
      </div>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="selectedProduto"
        title-class="text-brand-5 text-weight-bold"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns3"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        :rows-per-page-options="[0]"
        row-key="linha_id"
      >
        <template v-slot:body-cell-tipo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props"
            >NECESSIDADE</q-td
          >
        </template>

        <template v-slot:body-cell-desc="props">
          <q-td
            class="text-brand-5 text-weight-bold"
            :props="props"
            style="
              white-space: normal;
              word-break: break-word;
              max-width: 300px;
            "
          >
            {{ props.row.produto_descricao }}
          </q-td>
        </template>

        <template v-slot:body-cell-preco="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">{{
            formatPreco(props?.row?.produto_preco)
          }}</q-td>
        </template>

        <template v-slot:body-cell-quantidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-input
              style="font-size: 15px"
              class="input-lote-qtd"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              outlined
              type="number"
              min="1"
              dense
              v-model="props.row.quantidadeDigitada"
          /></q-td>
        </template>

        <template v-slot:body-cell-remover="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              icon="delete"
              color="negative"
              flat
              dense
              round
              @click="removerProduto(props.row.linha_id)"
            >
              <q-tooltip>Remover linha</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="col-12 q-mt-xl">
      <div class="q-ml-sm texto-titulo-input text-brand-1 text-weight-medium">
        Observações
      </div>
      <q-input
        type="textarea"
        label="Digite um histórico para a requisição se necessário for:"
        dense
        outlined
        v-model="observacao"
      />
    </div>

    <div class="row col-12 q-mb-sm q-mt-md">
      <q-btn
        dense
        color="positive"
        :disable="
          selectedProduto.length == 0 ||
          urgenciaValue?.value == undefined ||
          selectedCentro?.id == undefined ||
          !solicitanteSelecionado
        "
        icon="add"
        label="Criar Nova Necessidade"
        no-caps
        @click="finalDialog = true"
      />
    </div>
    <dialog-info-design
      class="row col-6"
      :width="'950px'"
      mensagem="Consulta de Produtos"
      :showConteudo="true"
      :showCancelar="true"
      :height="'550px'"
      :intern_height="'425px'"
      :exibir="confirm"
      @resultado="adicionarProdutosSelecionados"
    >
      <span class="text-brand-1 text-weight-bold">Produto:</span>
      <q-input dense outlined v-model="produtoModal">
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="listaProdutosAcciona"
        dense
        v-model:selected="selectedProdutoModal"
        class="tabela-tamanho-fixo q-mt-sm"
        :columns="columnsModal"
        selection="multiple"
        hide-pagination
        row-key="produto_id"
        :filter="filter"
        :rows-per-page-options="[0]"
      >
        <template #body-cell-previsao="props">
          <q-td>
            {{ props.row.tempoPermanencia }}
          </q-td>
        </template>
        <template #body-cell-atrasoDias="props">
          <q-td>
            {{ props.row?.ativosAtrasados[0]?.diferencaEmDia }}
          </q-td>
        </template>
        <template #body-cell-atrasoHoras="props">
          <q-td v-if="props.row?.ativosAtrasados[0]?.diferencaEmHora">
            {{
              props.row?.ativosAtrasados[0]?.diferencaEmHora > 0
                ? `${Math.floor(
                    props.row?.ativosAtrasados[0]?.diferencaEmHora
                  )} (Hr)`
                : `${(
                    props.row?.ativosAtrasados[0]?.diferencaEmHora / 60
                  ).toFixed(1)} (Min)`
            }}
          </q-td>
        </template>
      </q-table>
    </dialog-info-design>

    <dialog-info-design
      class="row col-6"
      :width="'950px'"
      mensagem="Consulta de Estoque"
      :showConteudo="true"
      :height="'550px'"
      :intern_height="'425px'"
      :exibir="confirmTabela"
      @resultado="
        (unidadeEstoque = { id: '', nome: 'Todas' }), (confirmTabela = false)
      "
    >
      <section>
        <span class="text-brand-1 text-weight-bold">Unidade:</span>
        <q-select
          dense
          outlined
          v-model="unidadeEstoque"
          :options="listaUnidades"
          :option-label="
            (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
          "
          :rules="[(val) => val || 'Campo Obrigatório']"
        >
          <template v-slot:prepend>
            <q-icon name="place" />
          </template>
        </q-select>
      </section>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rowsEstoque"
        dense
        class="tabela-tamanho-fixo q-mt-sm"
        :columns="columnsEstoque"
        hide-pagination
        v-model:pagination="pagination"
        :filter="filter"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:no-data>
          <div>Produto Sem Estoque Nesta Unidade</div>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </dialog-info-design>

    <dialog-info-design
      class="row col-6"
      :width="'950px'"
      mensagem="Consulta de Estoque"
      :showConteudo="true"
      :showCancelar="true"
      :height="'550px'"
      :intern_height="'425px'"
      :exibir="confirmTabelaVendor107"
      @resultado="confirmarSelecaoProdutoVendor107"
    >
      <section>
        <span class="text-brand-1 text-weight-bold">Unidade:</span>
        <q-select
          dense
          outlined
          v-model="unidadeVendor107"
          :options="[unidadeVendor107]"
          option-label="nome"
          disable
          bg-color="grey-3"
        >
          <template v-slot:prepend>
            <q-icon name="place" />
          </template>
        </q-select>
      </section>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rowsEstoqueVendor107"
        dense
        class="tabela-tamanho-fixo q-mt-sm"
        :columns="columnsEstoque"
        hide-pagination
        v-model:pagination="paginationVendor107"
        :filter="filter"
        :rows-per-page-options="[0]"
        :loading="loadingVendor107"
      >
        <template v-slot:no-data>
          <div>Produto Sem Estoque no DEPOSITO CIRCULAR</div>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="loadingVendor107"
          v-model="paginationVendor107.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumberVendor107"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </dialog-info-design>

    <dialog-info-design
      class="row col-12"
      mensagem="Detalhes Necessidade Compra"
      subMensagem="Preencha os dados abaixo para complementar os dados par auxiliar no processo de compras."
      :showConteudo="true"
      :showCancelar="true"
      :exibir="finalDialog"
      :desabilitarConfirme="
        finalDialogForm.data_aplicacao == '' ||
        finalDialogForm.justificativa_contratacao == '' ||
        !validarDataAplicacao(finalDialogForm.data_aplicacao)
      "
      @resultado="criarNecessidade"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="finalDialogForm.data_aplicacao"
          mask="##/##/####"
          :rules="[
            (val) => val || 'Campo obrigatório',
            (val) =>
              validarDataAplicacao(val) ||
              `Data deve ser igual ou posterior a ${dataMinima}`,
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="finalDialogForm.data_aplicacao"
                  :options="opcoesDataCalendario"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Justificativa Contratação *
        </div>
        <q-input
          v-model="finalDialogForm.justificativa_contratacao"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
        <q-input
          v-model="finalDialogForm.detalhamento_tecnico"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Fornecedores
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Contratante
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_contratante"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
        <q-input
          v-model="finalDialogForm.possiveis_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
// funçao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";

  let formatted = num.toFixed(4);

  const parts = formatted.split(".");
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === "0") {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + "." + decimals;
  }

  return `R$ ${formatted.replace(".", ",")}`;
};

const columnsModal = [
  {
    name: "produto",
    label: "Id Produto",
    field: (row) => row.produto_id,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: (row) => row.produto_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: (row) => row.produto_descricao,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
];

const columnsEstoque = [
  {
    name: "unidade",
    label: "Nome Unidade",
    field: (row) => row.Nome,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: (row) => row.Codigo,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: (row) => row.Descricao,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "medida",
    label: "Unidade Medida",
    field: (row) => row.Unidadade_Medida,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "grupo",
    label: "Grupo Produto",
    field: (row) => row.Grupo,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "familia",
    label: "Familia",
    field: (row) => row.Familia,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "valor unitario",
    label: "Valor Unitario",
    field: (row) => row.Valor,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "qtd",
    label: "Qtd Estoque",
    field: (row) => row.Quantidade,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
  {
    name: "valor total",
    label: "Valor total Estoque",
    field: (row) => row.Total,
    align: "left",
    style: "color: #707070; font-weight: bold; white-space: normal",
  },
];

const columns2 = [
  {
    name: "adicionar",
    label: "Adicionar",
    field: "adicionar",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    field: (row) => row.produto_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "desc",
    label: "Descrição",
    field: (row) => row.produto_descricao,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "categoria",
    label: "Categoria",
    field: (row) => row.categoria_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: (row) => row.endereco,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "preco",
    label: "Preço",
    field: "preco",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "unidade med",
    label: "Unid. Medida",
    field: (row) => row.unidade_medida,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "estoque",
    label: "Estoque",
    field: (row) => parseInt(row?.quantidade),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "estoque min",
    label: "Estoque Min",
    field: (row) => parseInt(row?.quantidade_reposicao),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "verificarEstoque",
    label: "Verificar Estoque",
    field: "verificarEstoque",
    align: "left",
  },
];

const columns3 = [
  {
    name: "tipo",
    label: "Tipo",
    field: "tipo",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "codigo",
    label: "Código",
    field: (row) => row.produto_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "desc",
    label: "Descrição",
    field: (row) => row.produto_descricao,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "categoria",
    label: "Categoria",
    field: (row) => row.categoria_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: (row) => row.endereco,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "preco",
    label: "Preço",
    field: "preco",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "unidade med",
    label: "Unid. Medida",
    field: (row) => row.unidade_medida,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "estoque",
    label: "Estoque",
    field: (row) => parseInt(row?.quantidade),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "estoque min",
    label: "Estoque Min",
    field: (row) => parseInt(row?.quantidade_reposicao),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "quantidade",
    label: "Quantidade",
    field: "quantidade",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelectSolicitanteCompra from "../../compras/components/SelectSolicitanteCompra.vue";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";

export default {
  components: {
    ListaUnidadesSelect,
    DialogInfoDesign,
    SelectSolicitanteCompra,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const $q = useQuasar();

    const disable = ref(true);
    const filtrar = ref("");
    const selectedCentro = ref(null);
    const confirm = ref(false);
    const confirmTabela = ref(false);
    const produtoModal = ref("");
    const produtoVerificarEstoqueId = ref(null);
    const rowsEstoque = ref([]);
    const listaProdutosAcciona = ref([]);
    const selectedProduto = ref([]);
    const selectedProdutoModal = ref([]);
    const listaUnidades = ref([]);
    const selectedModal = ref([]);
    const time = ref(null);
    const finalDialog = ref(false);
    const finalDialogForm = ref({
      data_aplicacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
      justificativa_contratacao: "",
    });
    const observacao = ref("");
    const dataMinima = ref("");

    const confirmTabelaVendor107 = ref(false);
    const rowsEstoqueVendor107 = ref([]);
    const loadingVendor107 = ref(false);
    const produtoPendenteSelecao = ref(null);
    const paginationVendor107 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 30,
      rowsNumber: 30,
    });
    const unidadeVendor107 = ref({ id: 107, nome: "DEPOSITO CIRCULAR" });

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });

    let unidadeEstoque = ref("");
    const unidadeAcciona = ref("CENTRAL");
    const urgenciaValue = ref("SELECIONE UMA URGENCIA");
    const pesquisarCentro = ref("");
    const pesquisarProduto = ref("");
    const listaProdutos = ref([]);
    const solicitanteSelecionado = ref(null);
    const selectedProdutoTemp = ref([]);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 30,
      rowsNumber: 30,
    });

    const isAccionaClient = () => {
      return (
        store.state.autenticacao.cliente.includes("acciona") ||
        store.state.autenticacao.cliente.includes("staging-acciona")
      );
    };

    const listarEstoqueVendor107 = async (
      codigoProduto,
      page = 1,
      rowsPerPage = 30
    ) => {
      loadingVendor107.value = true;
      rowsEstoqueVendor107.value = [];

      try {
        const response = await store.dispatch(
          "comprasSolicitante/listarEstoqueSelecionado",
          {
            page: page,
            per_page: rowsPerPage,
            cod_produto: codigoProduto,
            vendor_id: 107,
            com_saldo: 1,
          }
        );

        rowsEstoqueVendor107.value = response.data.data;
        paginationVendor107.value.rowsNumber = response.data.total || 0;

        loadingVendor107.value = false;
      } catch (error) {
        loadingVendor107.value = false;
        rowsEstoqueVendor107.value = [];
        $q.notify({
          message: "Erro ao procurar estoque no DEPOSITO CIRCULAR",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const confirmarSelecaoProdutoVendor107 = (resultado) => {
      confirmTabelaVendor107.value = false;

      if (resultado && produtoPendenteSelecao.value) {
        const jaExiste = selectedProduto.value.some(
          (p) =>
            p.produto_id === produtoPendenteSelecao.value.produto_id &&
            !p.linha_id
        );

        if (!jaExiste) {
          selectedProduto.value.push({
            ...produtoPendenteSelecao.value,
            quantidadeDigitada: 1,
            linha_id: `sel_${Date.now()}_${
              produtoPendenteSelecao.value.produto_id
            }`,
          });
        }

        // Adiciona à seleção do checkbox
        if (
          !selectedProdutoTemp.value.some(
            (p) => p.produto_id === produtoPendenteSelecao.value.produto_id
          )
        ) {
          selectedProdutoTemp.value.push(produtoPendenteSelecao.value);
        }
      } else {
        // Remove da seleção do checkbox se cancelar
        selectedProdutoTemp.value = selectedProdutoTemp.value.filter(
          (p) => p.produto_id !== produtoPendenteSelecao.value?.produto_id
        );
      }

      produtoPendenteSelecao.value = null;
      rowsEstoqueVendor107.value = [];
      paginationVendor107.value.page = 1;
    };

    const getProdutosLista = async (codigosEspecificos = null) => {
      try {
        const response = await store.dispatch("compras/getProdutosLista", {
          vendor_id: getVendorId(),
          produto: codigosEspecificos || pesquisarProduto.value,
          sem_obsoleto:
            store.state.autenticacao.cliente[0] == "staging-acciona" ||
            store.state.autenticacao.cliente[0] == "acciona"
              ? 1
              : undefined,
        });

        if (codigosEspecificos) {
          return response.data.data;
        } else {
          listaProdutos.value = response.data.data;
        }
      } catch (error) {
        console.log(error);
        return [];
      }
    };

    const listarProdutosAcciona = async () => {
      disable.value = true;
      try {
        const response = await store.dispatch(
          "comprasSolicitante/listarProdutosAcciona",
          {
            descricao: produtoModal.value,
          }
        );

        listaProdutosAcciona.value = response.data.map((row) => {
          return {
            produto_codigo: row._source.codigo,
            produto_descricao: row._source.descricao,
            produto_id: row._source.id_produto,
            produto_preco: 0,
            quantidade_reposicao: 0,
            quantidade: 0,
          };
        });

        disable.value = false;
      } catch (error) {
        disable.value = false;
        $q.notify({
          message: "Erro procurar produtos acciona",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarProdutosSelecionados = async (resultado) => {
      confirm.value = false;

      if (resultado && selectedProdutoModal.value.length > 0) {
        try {
          $q.loading.show();

          // Buscar os produtos completos um por um
          const produtosCompletos = [];

          for (const produtoModal of selectedProdutoModal.value) {
            try {
              const produtoCompleto = await getProdutosLista(
                produtoModal.produto_codigo
              );
              if (produtoCompleto && produtoCompleto.length > 0) {
                produtosCompletos.push(produtoCompleto[0]); // Pega o primeiro resultado
              }
            } catch (error) {
              console.warn(
                `Erro ao buscar produto ${produtoModal.produto_codigo}:`,
                error
              );
            }
          }

          // Filtrar produtos que já não estão selecionados
          const produtosNovos = produtosCompletos.filter(
            (produtoCompleto) =>
              !selectedProduto.value.some(
                (produtoSelecionado) =>
                  produtoSelecionado.produto_id === produtoCompleto.produto_id
              )
          );

          // Adicionar quantidadeDigitada aos novos produtos
          const produtosComQuantidade = produtosNovos.map((produto) => ({
            ...produto,
            quantidadeDigitada: 1,
          }));

          // Adicionar aos produtos selecionados
          selectedProduto.value = [
            ...selectedProduto.value,
            ...produtosComQuantidade,
          ];

          // Limpar seleção do modal
          selectedProdutoModal.value = [];

          $q.notify({
            message:
              produtosNovos.length > 0
                ? ` ${produtosNovos.length} produto(s) adicionado(s) com sucesso`
                : "Nenhum produto encontrado",
            color: produtosNovos.length > 0 ? "positive" : "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          console.error("Erro ao adicionar produtos:", error);
          $q.notify({
            message: "Erro ao adicionar produtos selecionados",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } finally {
          $q.loading.hide();
        }
      }
    };

    const listarEstoqueSelecionado = async (page = 1, rowsPerPage = 30) => {
      disable.value = true;
      $q.loading.show();
      rowsEstoque.value = [];

      try {
        const response = await store.dispatch(
          "comprasSolicitante/listarEstoqueSelecionado",
          {
            page: page,
            per_page: rowsPerPage,
            cod_produto: produtoVerificarEstoqueId.value,
            vendor_id:
              unidadeEstoque.value.id == ""
                ? undefined
                : unidadeEstoque.value.id,
          }
        );

        rowsEstoque.value = response.data.data;

        disable.value = false;
        $q.loading.hide();
      } catch (error) {
        $q.loading.hide();

        disable.value = false;
        rowsEstoque.value = [];
        $q.notify({
          message: "Erro procurar produtos do estoque",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getVendorId = () => {
      const isAcciona =
        store.state.autenticacao.cliente.includes("acciona") ||
        store.state.autenticacao.cliente.includes("staging-acciona");
      return isAcciona ? 1 : store.state.org.unidadeData.id;
    };

    const criarNecessidade = async (resultado) => {
      finalDialog.value = false;
      if (resultado) {
        try {
          const response = await store.dispatch(
            "compras/criarNecessidadeSolicitante",

            {
              vendor_id: getVendorId(),

              cost_center_id: selectedCentro?.value?.id,
              solicitante_id: solicitanteSelecionado.value.id,
              tag_id: urgenciaValue.value.value,
              observacao: observacao.value,
              data_aplicacao:
                finalDialogForm.value.data_aplicacao == ""
                  ? undefined
                  : finalDialogForm.value.data_aplicacao
                      ?.split("/")
                      ?.reverse()
                      ?.join("-"),
              detalhamento_tecnico:
                finalDialogForm.value.detalhamento_tecnico == ""
                  ? undefined
                  : finalDialogForm.value.detalhamento_tecnico,
              responsabilidades_fornecedores:
                finalDialogForm.value.responsabilidades_fornecedores == ""
                  ? undefined
                  : finalDialogForm.value.responsabilidades_fornecedores,
              responsabilidades_contratante:
                finalDialogForm.value.responsabilidades_contratante == ""
                  ? undefined
                  : finalDialogForm.value.responsabilidades_contratante,
              possiveis_fornecedores:
                finalDialogForm.value.possiveis_fornecedores == ""
                  ? undefined
                  : finalDialogForm.value.possiveis_fornecedores,
              justificativa_contratacao:
                finalDialogForm.value.justificativa_contratacao == ""
                  ? undefined
                  : finalDialogForm.value.justificativa_contratacao,

              produtos: selectedProduto?.value?.map((value) => {
                return {
                  id: value.produto_id,
                  codigo: value.produto_codigo,
                  centro_custo_id: selectedCentro?.value?.id,
                  quantidade: value.quantidadeDigitada,
                };
              }),
            }
          );

          listaProdutos.value = response.data.data;
          $q.notify({
            message: "Necessidade Criada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          router.push({ name: "compras-listar-necessidades-solicitante" });
        } catch (error) {
          $q.notify({
            message:
              "Preencha a quantidade do Produto ou Selecione uma Urgencia",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const handleRequest = async () => {
      listarEstoqueSelecionado(
        pagination.value.page,
        pagination.value.rowsPerPage
      );
    };

    const listaCentroCustos = ref([]);

    const listarCentroCustos = async (val) => {
      try {
        const response = await store.dispatch("compras/getCentrosCustos", {
          vendor_id: getVendorId(),
          search: val,
          page: 1,
        });

        listaCentroCustos.value = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const calcularDataAplicacao = (urgencia) => {
      const hoje = new Date();
      let diasAdicionar = 0;

      switch (urgencia?.value) {
        case 1: // NORMAL
          diasAdicionar = 15;
          break;
        case 2: // URGENTE
          diasAdicionar = 10;
          break;
        case 3: // MAQUINA PARADA
          diasAdicionar = 7;
          break;
        default:
          return "";
      }

      const dataFutura = new Date(hoje);
      dataFutura.setDate(hoje.getDate() + diasAdicionar);

      const dia = String(dataFutura.getDate()).padStart(2, "0");
      const mes = String(dataFutura.getMonth() + 1).padStart(2, "0");
      const ano = dataFutura.getFullYear();

      return `${dia}/${mes}/${ano}`;
    };

    const validarDataAplicacao = (data) => {
      if (!data || !dataMinima.value) return true;

      const [diaData, mesData, anoData] = data.split("/");
      const [diaMinima, mesMinima, anoMinima] = dataMinima.value.split("/");

      const dataEscolhida = new Date(anoData, mesData - 1, diaData);
      const dataMinPermitida = new Date(anoMinima, mesMinima - 1, diaMinima);

      return dataEscolhida >= dataMinPermitida;
    };

    const converterDataParaQDate = (dataString) => {
      if (!dataString) return null;
      const [dia, mes, ano] = dataString.split("/");
      return `${ano}/${mes.padStart(2, "0")}/${dia.padStart(2, "0")}`;
    };

    const opcoesDataCalendario = (date) => {
      if (!dataMinima.value) return true;

      const dataMinFormatada = converterDataParaQDate(dataMinima.value);
      return date >= dataMinFormatada;
    };

    const adicionarProduto = (produto) => {
      const novoProduto = {
        ...produto,
        quantidadeDigitada: 1,
        linha_id: Date.now(),
      };
      selectedProduto.value.push(novoProduto);
    };

    const removerProduto = (linha_id) => {
      selectedProduto.value = selectedProduto.value.filter(
        (produto) => produto.linha_id !== linha_id
      );
    };

    watch(
      () => urgenciaValue.value,
      (novaUrgencia) => {
        if (novaUrgencia?.value) {
          const dataCalculada = calcularDataAplicacao(novaUrgencia);
          finalDialogForm.value.data_aplicacao = dataCalculada;
          dataMinima.value = dataCalculada;
        } else {
          finalDialogForm.value.data_aplicacao = "";
          dataMinima.value = "";
        }
      }
    );

    watch(
      () => selectedProdutoTemp.value,
      (novosSelecionados, antigosSelectionados) => {
        if (isAccionaClient()) {
          const produtosAdicionados = novosSelecionados.filter(
            (novo) =>
              !antigosSelectionados?.some(
                (antigo) => antigo.produto_id === novo.produto_id
              )
          );

          if (produtosAdicionados.length > 0) {
            const produto = produtosAdicionados[0];
            produtoPendenteSelecao.value = produto;

            listarEstoqueVendor107(produto.produto_codigo);
            confirmTabelaVendor107.value = true;

            return;
          }
        } else {
          const produtosAdicionados = novosSelecionados.filter(
            (novo) =>
              !antigosSelectionados?.some(
                (antigo) => antigo.produto_id === novo.produto_id
              )
          );

          produtosAdicionados.forEach((produto) => {
            const jaExiste = selectedProduto.value.some(
              (p) => p.produto_id === produto.produto_id && !p.linha_id
            );

            if (!jaExiste) {
              selectedProduto.value.push({
                ...produto,
                quantidadeDigitada: 1,
                linha_id: `sel_${Date.now()}_${produto.produto_id}`,
              });
            }
          });
        }

        const produtosRemovidos =
          antigosSelectionados?.filter(
            (antigo) =>
              !novosSelecionados.some(
                (novo) => novo.produto_id === antigo.produto_id
              )
          ) || [];

        produtosRemovidos.forEach((produto) => {
          const linhasDoProduto = selectedProduto.value.filter(
            (p) => p.produto_id === produto.produto_id
          );

          if (linhasDoProduto.length === 1) {
            selectedProduto.value = selectedProduto.value.filter(
              (p) => p.produto_id !== produto.produto_id
            );
          }
        });
      }
    );

    watch(
      () => paginationVendor107.value.page,
      () => {
        if (confirmTabelaVendor107.value && produtoPendenteSelecao.value) {
          listarEstoqueVendor107(
            produtoPendenteSelecao.value.produto_codigo,
            paginationVendor107.value.page,
            paginationVendor107.value.rowsPerPage
          );
        }
      }
    );

    watch(
      () => finalDialogForm.value.data_aplicacao,
      (novaData) => {
        if (novaData && dataMinima.value) {
          validarDataAplicacao(novaData);
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => selectedCentro.value,
      () => {
        getProdutosLista();
      }
    );

    watch(
      () => pesquisarCentro.value,
      () => {
        listarCentroCustos();
      }
    );

    watch(
      () => pesquisarProduto.value,
      () => {
        getProdutosLista();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getProdutosLista();
      }
    );

    watchDebounced(
      () => produtoModal.value,
      () => {
        listarProdutosAcciona();
      },
      { debounce: 800 }
    );

    watchDebounced(
      () => produtoVerificarEstoqueId.value,
      () => {
        listarEstoqueSelecionado();
        confirmTabela.value = true;
      },
      { debounce: 800 }
    );

    watchDebounced(
      () => unidadeEstoque.value.id,
      () => {
        if (confirmTabela.value) {
          listarEstoqueSelecionado();
        }
      },
      { debounce: 800 }
    );

    onMounted(() => {
      listarCentroCustos();
      getProdutosLista();
      listarProdutosAcciona();
      listarUnidades();
    });

    let listarUnidades = async () => {
      try {
        const resposta = await store.dispatch("org/listarUnidades", {});

        listaUnidades.value = resposta.listaUnidades;
        listaUnidades.value.unshift({
          id: "",
          nome: "Todas",
        });
        unidadeEstoque.value = listaUnidades.value[0];
      } catch (error) {
        console.error(error);
      }
    };

    return {
      pagination,

      disable,
      listaProdutosAcciona,
      filtrar,

      urgenciaValue,
      listarCentroCustos,
      selectedCentro,
      listaCentroCustos,
      pesquisarCentro,
      pesquisarProduto,
      handleRequest,
      selectedProduto,
      listaProdutos,
      columns2,
      columns3,
      time,
      observacao,
      confirm,
      confirmTabela,
      produtoModal,
      finalDialog,
      criarNecessidade,
      finalDialogForm,
      unidade,
      unidadeAcciona,
      columnsEstoque,
      validarDataAplicacao,
      converterDataParaQDate,
      opcoesDataCalendario,
      dataMinima,
      getVendorId,
      solicitanteSelecionado,
      selectedProdutoTemp,
      formatPreco,

      confirmTabelaVendor107,
      rowsEstoqueVendor107,
      loadingVendor107,
      paginationVendor107,
      confirmarSelecaoProdutoVendor107,
      unidadeVendor107,
      pagesNumberVendor107: computed(() =>
        Math.ceil(
          paginationVendor107.value.rowsNumber /
            paginationVendor107.value.rowsPerPage
        )
      ),
      isAccionaClient,
      filterCenter(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarCentroCustos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      filtrosComprados: [
        {
          label: "Comprados",
          value: 1,
        },
        {
          label: "Não Comprados",
          value: 0,
        },
        {
          label: "Todos",
          value: 2,
        },
      ],

      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      urgencia: [
        {
          label: "SELECIONE UMA URGENCIA",
          value: undefined,
        },
        { label: "NORMAL", value: 1 },
        { label: "URGENTE", value: 2 },
        { label: "MÁQUINA PARADA", value: 3 },
      ],
      columnsModal,
      selectedModal,
      produtoVerificarEstoqueId,
      rowsEstoque,
      unidadeEstoque,
      listaUnidades,
      listarUnidades,
      selectedProdutoModal,
      adicionarProdutosSelecionados,
      adicionarProduto,
      removerProduto,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
theader tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap !important;
}

a {
  text-decoration: none;
}
.align {
  align-items: center;
}
.input-lote-qtd {
  width: 80px;
  margin-left: 5px;
  font-size: 11px;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
